import usegetdata from '../../Hooks/useGetData';
import { Get_All_Leads_For_Admin_Type, Get_Error } from '../Types';

export const Getalldatasearch_For_Admin = (quary) => async (dispatch) => {
  try {
    const res = await usegetdata(`api/v1/users/admin/allleadspagination?${quary}`);

    dispatch({
      type: Get_All_Leads_For_Admin_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};
